import { convertToBlockquote, convertToCalloutInfo } from './operations';

export const slashMenu = {
  Blockquote: { icon: 'quotes', basic: true, shortcut: '>', transform: convertToBlockquote },
  Callout: { icon: 'callout-info', shortcut: '>📘', transform: convertToCalloutInfo },
};

export default slashMenu;
